export default {
  products: 'name',
  salesman: 'salesman',
  outlets: 'createdAt',
  'outlet-revenue': 'createdAt',
  'payment-methods': 'createdAt',
  cashiers: 'cashier',
  registers: 'registerName',
  'total-revenues': 'createdAt',
  'sale-summary': 'createdAt',
  'fulfillment-summary': 'createdAt',
  categories: 'productCategoryName',
  globalReport: 'createdAt'
}
